import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

const RECOVERY = 'recovery';

export default {
    methods: {
        async checkPasswordResetToken() {
            const url = `${baseURL}${RECOVERY}`
            const response = await this.httpSession().get(url)
            console.debug('[RECOVERY][checkPasswordResetToken] list:', response.data)
            return response.data;
        },

        async createNewPasswordRecovery(data) {
            console.debug('[RECOVERY][createNewPasswordRecovery] request data', data.userId)
            const url = `${baseURL}${RECOVERY}/${data.userId}`
            const response = await this.httpSession().post(url, {newPassword: data.newPassword})
            console.debug('[RECOVERY][createNewPasswordRecovery] :', response)
            return response.data
        },

        async recoverPassword(data) {
            console.debug('[RECOVERY][recoverPassword] request data', data)
            const url = `${baseURL}${RECOVERY}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[RECOVERY][recoverPassword] :', response)
            return response.data
        },

        async getUserByPasswordResetToken(passwordToken) {
            console.debug('[RECOVERY][getUserByPasswordResetToken] request data', passwordToken)
            const url = `${baseURL}${RECOVERY}/user/${passwordToken}`
            const response = await this.httpSession().get(url)
            console.debug('[RECOVERY][getUserByPasswordResetToken] :', response)
            return response.data
        },

        async reminderExpirationPassword(data) {
            console.debug('[RECOVERY][reminderExpirationPassword] request data', data)
            const url = `${baseURL}${RECOVERY}/expiration`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[RECOVERY][reminderExpirationPassword] :', response)
            return response.data
        },
    },
    mixins: [SessionApi],
};
